export const nftContractAddress = "0x666AAbd9e413E6A76f488C67E3F93D40Ba342d06"

export const alk = "U2RmRHZuaGFCY1YzMHg5am5jRUttaW5KZzRzVUplM1A=";

